import { useAuth } from "@onefront/react-sdk";
import { AuthProviders } from "./authproviders";
import { useBrowserStorage } from "../../../hooks/useBrowserStorage";
import { useEffect } from "react";
const { version } = require("../../../../package.json");

export const Root = ({ children }) => {
    const versionStorage = useBrowserStorage("version");
    const { get, set } = versionStorage;

    const auth = useAuth();

    useEffect(() => {
        if (get() !== version) {
            localStorage.clear();
            set(version);
            window.location.reload();
        }
    }, [get, set]);

    if (!auth?.token && !auth?.tokenData) {
        return <>{children}</>;
    }

    return <AuthProviders>{children}</AuthProviders>;
};
